import { render } from "./DialogDetailComponent.vue?vue&type=template&id=44057951&scoped=true"
import script from "./DialogDetailComponent.vue?vue&type=script&lang=js"
export * from "./DialogDetailComponent.vue?vue&type=script&lang=js"

import "./DialogDetailComponent.vue?vue&type=style&index=0&id=44057951&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44057951"]])

export default __exports__